<template>
  <v-card class="stage-card" tile>
    <div
      class="stage-card-header text-h6 mx-6 py-6"
      :class="headerClass"
    >
      <slot name="header"></slot>
      <slot name="progress-chip">
        <stage-card-progress-chip
          :progress="progress"
          :pending-label="progressPendingLabel"
        />
      </slot>
    </div>
    <div v-if="showContentAndActions" class="stage-card-content pa-6">
      <slot name="content"></slot>
    </div>
    <div v-if="showContentAndActions" class="stage-card-actions pa-3">
      <slot name="actions"></slot>
    </div>
  </v-card>
</template>

<script>
import StageCardProgressChip from './StageCardProgressChip';
import { StageCardProgress } from '@/enums';
import { kebabCase } from 'lodash';

export default {
  name: 'StageCard',
  components: { StageCardProgressChip },
  props: {
    progress: {
      type: String,
      default: StageCardProgress.PENDING,
      validator: (val) =>
        Object.values(StageCardProgress).includes(val),
    },
    progressPendingLabel: {
      type: String,
      default: 'Pending',
    },
    alwaysShowContentAndActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showContentAndActions() {
      return (
        this.progress !== StageCardProgress.PENDING ||
        this.alwaysShowContentAndActions
      );
    },
    progressAsClass() {
      return kebabCase(this.progress);
    },
    headerClass() {
      return [
        this.progressAsClass,
        { ['always-showing']: this.alwaysShowContentAndActions },
      ];
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.stage-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:is(.always-showing, .in-progress, .complete) {
    border-bottom: 1px solid map-get($grey, 'lighten-2');
  }
}

.stage-card-content {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 32px;

  // Right border for each column (except the last one)
  > *:not(:last-child) {
    border-right: 1px solid map-get($grey, 'lighten-2');
    padding-right: 32px;
  }
}

.stage-card-actions {
  display: flex;
  justify-content: flex-end;
  background-color: map-get($grey, 'lighten-5');
  border-top: 1px solid map-get($grey, 'lighten-2');
}
</style>
